var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "watch",
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7644 3.7124H3.7251V5.57517H16.7644V3.7124Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7644 7.11816H3.7251V8.98093H16.7644V7.11816Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2321 10.6772H3.55884V12.4568H10.2321V10.6772Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6276 0H1.86276C0.839556 0 0 0.826438 0 1.86276V25.0686C0 25.5802 0.419778 26 0.931382 26H1.86276C2.15136 26 2.42684 25.8688 2.61049 25.6327L4.65691 22.9041L6.70333 25.6327C7.0444 26.0394 7.64783 26.1049 8.05449 25.7639C8.10696 25.7245 8.14632 25.6852 8.18567 25.6327L10.2321 22.9041L12.2785 25.6327C12.6196 26.0394 13.223 26.1049 13.6297 25.7639C13.6821 25.7245 13.7215 25.6852 13.7608 25.6327L15.8073 22.9041L17.8537 25.6327C18.0242 25.8688 18.2997 26 18.6014 26H19.5328C20.0444 26 20.4642 25.5802 20.4642 25.0686V1.86276C20.4904 0.826438 19.664 0 18.6276 0ZM18.6276 23.5207L16.5812 20.7921C16.2402 20.3855 15.6367 20.3199 15.2301 20.6609C15.1776 20.7003 15.1382 20.7397 15.0989 20.7921L13.0525 23.5207L11.0061 20.7921C10.665 20.3855 10.0616 20.3199 9.65489 20.6609C9.60242 20.7003 9.56307 20.7397 9.52371 20.7921L7.47729 23.5207L5.43088 20.7921C5.08981 20.3855 4.48638 20.3199 4.07972 20.6609C4.02725 20.7003 3.98789 20.7397 3.94854 20.7921L1.90212 23.5207V1.86276H18.6276V23.5207Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.33765cd048bf3c2dee5530b4b0732cc9.svg";
export { ForwardRef as ReactComponent };